// @flow
import { APICore } from "./apiCore";

const api = new APICore();

function ApiGetAllPegawai(params: any): any {
  const baseUrl = "/api/admin/pegawais";
  return api.get(`${baseUrl}`, params);
}
function ApiPostPegawai(params: any): any {
  const baseUrl = "/user/pegawais";
  return api.create(`${baseUrl}`, params);
}
function ApiEditPegawai(params: any, id: any): any {
  const baseUrl = "/api/admin/pegawai";
  return api.update(`${baseUrl}/${id}`, params);
}
function ApiEditPasswordPegawai(params: any, id: any): any {
  const baseUrl = "/api/admin/department/" + id;
  return api.update(`${baseUrl}`, params);
}
function ApiDeletePegawai(id: any): any {
  const baseUrl = "/api/admin/pegawai/" + id;
  return api.delete(`${baseUrl}`);
}

export {
  ApiGetAllPegawai,
  ApiPostPegawai,
  ApiEditPasswordPegawai,
  ApiEditPegawai,
  ApiDeletePegawai,
};
